import { render, staticRenderFns } from "./RegrasDescontoList.vue?vue&type=template&id=060a30a5&scoped=true"
import script from "./RegrasDescontoList.vue?vue&type=script&lang=js"
export * from "./RegrasDescontoList.vue?vue&type=script&lang=js"
import style0 from "./RegrasDescontoList.vue?vue&type=style&index=0&id=060a30a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a30a5",
  null
  
)

export default component.exports